// extracted by mini-css-extract-plugin
export default {"root":"empty-module__root--eJwcw","titleContainer":"empty-module__titleContainer--K2RGE","title":"empty-module__title--pqdTS"};